import { clearRetailCompaniesFilter } from '@/app/globalRedux/filter/retail/retailCompanyFilter'
import { clearRetailNewsFilter } from '@/app/globalRedux/filter/retail/retailnewsFilter'
import { useTranslation } from '@/app/i18n/client'
import { useDispatch } from 'react-redux'

const ClearAllRetailFilters = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const clearRetailFilters = () => {
    dispatch(clearRetailNewsFilter())
    dispatch(clearRetailCompaniesFilter())
  }
  return (
    <div className="text-[16px] px-[15px] py-[10px] shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-[#fafafa] border border-solid border-[#ebebeb] w-full flex rounded-[4px]">
      <span className=" text-[18px] font-ns_semibold text-left	">
        {t('Filters')}
      </span>

      <span
        className=" text-primary ml-auto flex text-[12px] items-center font-ns_bold cursor-pointer mobile:mr-[5px]"
        onClick={() => {
          clearRetailFilters()
        }}
      >
        {t('Clear All')}
      </span>
    </div>
  )
}

export default ClearAllRetailFilters
